import { render, staticRenderFns } from "./AddWorshipForm.vue?vue&type=template&id=046653ce&scoped=true&"
import script from "./js/add-worship-form.js?vue&type=script&lang=js&"
export * from "./js/add-worship-form.js?vue&type=script&lang=js&"
import style0 from "./AddWorshipForm.vue?vue&type=style&index=0&id=046653ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046653ce",
  null
  
)

export default component.exports